/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2023 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{buf82hex as e}from"@keeex/js-utils/lib/uint8array.js";import{importKey as r}from"../keys.js";import{KeyType as s}from"../shared/types.js";const t=e=>r(s.bitcoin,{type:"passphrase",passphrase:e});export const convertRecipientKeyToKeypair=async r=>"string"==typeof r?t(r):r instanceof Uint8Array?(r=>t(e(r)))(r):r;export const convertAllToKeypair=async e=>Promise.all(e.map(convertRecipientKeyToKeypair));